// import { useNavigate } from "react-router-dom";

// Components & Molecules
import PageHero from "../PageHero";
import PageSection from "../PageSection";
import ResourceHow from "./ResourceHow";
import PageForm from "../PageForm";
import Button from "../../../components/Desktop/Button";

// Images
import hero_bka_a from "../../../assets/img/ResourceProviders/Desktop/hero_bkg_a.png";
import hero_bka_b from "../../../assets/img/ResourceProviders/Desktop/hero_bkg_b.png";
import sect1_img from "../../../assets/img/ResourceProviders/Desktop/sect1_img.png";
import sect2_img from "../../../assets/img/ResourceProviders/Desktop/sect2_img.png";
import sect3_img from "../../../assets/img/ResourceProviders/Desktop/sect3_img.png";

import { ReactComponent as TailedArrowRightIcon } from "../../../icons/TailedArrowRightIcon.svg";

import config from "../../../config";
const { partnerDashboardUrl } = config;

const ResourceSections = () => {
  const bookDemoUrl =
    "https://calendly.com/homecook/homecook-resource-provider-demo";

  return (
    <>
      {/* Hero Section */}
      <PageHero
        bkg_a={hero_bka_a}
        bkg_b={hero_bka_b}
        sub_head={"Resource Providers"}
        main_head={
          <>
            <span className="text-primaryDark-400"> Monetize Your </span> Space
            Today
          </>
        }
        description={
          <>
            Transform your excess capacity into earnings with HomeCook’s
            reliable platform that allows you to safely manage bookings, receive
            payments and connect with pre- vetted food entrepreneurs.
          </>
        }
        children={
          <>
            <Button
              label={
                <>
                  Partner Dashboard{" "}
                  <TailedArrowRightIcon className="w-[20px] h-[20px]" />
                </>
              }
              variant="secondary"
              onClick={() => {
                window.open(partnerDashboardUrl, "_blank");
              }}
            />
          </>
        }
      />

      {/* Section One */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Diversify Revenue </span>{" "}
            Streams <br />
            Effortlessly
          </>
        }
        description={
          <>
            List your kitchen with HomeCook and effortlessly tap into various
            revenue streams. Let your kitchen work for you by booking it to pre-
            vetted food entrepreneurs.
          </>
        }
        pageSectionVariant="primary"
        button={{
          label: "Book Demo",
          variant: "secondary",
          onClick: () => {
            window.open(bookDemoUrl, "_blank");
          },
        }}
        image={sect1_img}
      />

      {/* Section Two */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Seamlessly </span> Manage
            Bookings
          </>
        }
        description={
          <>
            Easily manage bookings with HomeCook, set your availability, and
            stay in charge of your kitchen’s calendar.
          </>
        }
        pageSectionVariant="secondary"
        button={{
          label: "Book Demo",
          variant: "secondary",
          onClick: () => {
            window.open(bookDemoUrl, "_blank");
          },
        }}
        image={sect2_img}
      />

      {/* Section Three */}
      <PageSection
        heading={
          <>
            <span className="text-primaryDark-400"> Bring Your </span> Community
            To <br />
            HomeCook
          </>
        }
        description={
          <>
            Create and manage your own community on the platform, share valuable
            resources, and support food entrepreneurs while expanding your reach
            and impact.
          </>
        }
        pageSectionVariant="primary"
        button={{
          label: "Book Demo",
          variant: "secondary",
          onClick: () => {
            window.open(bookDemoUrl, "_blank");
          },
        }}
        image={sect3_img}
      />

      {/* How It Works Section */}
      <ResourceHow />

      {/* Resource Provider Form */}
      <PageForm buttonLabel="Join" />
    </>
  );
};

export default ResourceSections;
